<template>
  <div class="home">
    <QRCodeGenerator />
    <HomeWidgetsPermanent />
    <hr
      style="
        border: 0.5px lightgrey solid;
        margin-top: 0px;
        width: 100vw;
        margin-bottom: 18px;
      "
    />

    <HomeDrawings v-show="!$store.state.superUser" />

    <div v-show="$store.state.superUser" class="buttons-wrapper">
      <div class="buttons is-centered">
        <button v-ripple class="button is-danger" @click="forceClearCache">
          Cache
        </button>
        <button class="button is-primary" @click="clearCookies" v-ripple>
          Store
        </button>
        <button class="button is-link" @click="clearLocation">Location</button>
        <button class="button" @click="qrCodes">QR Code</button>
        <!-- <button class="button is-success" @click="toggleMagic">Magic</button> -->
        <button class="button is-success" @click="goto('home')">
          New Home
        </button>
        <button class="button is-warning" @click="$router.push('/cb')">
          CB
        </button>
        <button class="button is-info" @click="deliveryPriceCheck">
          Price Check
        </button>
        <button
          class="button is-dark"
          @click="$router.push('/logistics_fleet')"
        >
          Logistics
        </button>
      </div>
    </div>
    <figure class="image is-96x96" @click="toggleSuperUser">
      <!-- <img src="../../public/img/icons/new-round-512.png" /> -->
      <img src="../../public/img/icons/round-512x512.png" />
    </figure>
    <HomeMenu />
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import { clearCache } from "../functions";
import HomeMenu from "@/components/HomeMenu.vue";
import QRCodeGenerator from "@/components/QRCodeGenerator.vue";
import HomeWidgetsPermanent from "@/components/HomeWidgetsPermanent.vue";
import HomeDrawings from "@/components/HomeDrawings.vue";

export default {
  name: "Home",
  components: {
    HomeMenu,
    HomeWidgetsPermanent,
    HomeDrawings,
    QRCodeGenerator,
  },
  data() {
    return {
      buildTimestamp: process.env.VUE_APP_BUILD_TIMESTAMP,
      loading: true,
    };
  },
  computed: {
    superState() {
      return !this.$store.state.superUser;
    },
  },
  created() {},
  activated() {
    this.checkVersion();
    // this.checkMessages();
    this.updateAllWorkflows();
    this.checkWelcomeTo();
    this.refreshTransport();
    this.updateTrips(false);
    this.$store.commit("selectDriver", null); // turn off dispatch mode
  },
  beforeDestroy() {},
  mounted() {
    this.$store.commit("toggleSuperUser", false);
    this.$cookies.set("full_path", this.$route.fullPath);
    this.checkLangQuery();
    this.checkFCMQuery();
    var query = `query [${JSON.stringify(this.$route.query)}]`;
    EventBus.$emit("DEBUG", query);
    this.checkStartURL(); // check if user has another preferred start_url
  },
  methods: {
    checkStartURL() {
      var startURL = this.$store.getters.getStartURL;
      this.console(`check startURL [ ${startURL} ]`, this.$route.path);
      if (this.$route.path === "/" && startURL) this.goto(startURL);
    },
    clearLocation() {
      this.$store.commit("clearLocation");
      this.$swal({
        title: "Location cleared!",
        showConfirmButton: false,
        timer: 300,
      });
      this.toggleSuperUser();
    },
    clearCookies() {
      this.$cookies.keys().forEach((k) => this.$cookies.remove(k));
      localStorage.clear();
      this.$swal({
        title: "Cookies and localStorage cleared!", // clears all cookies, unlike logout
        showConfirmButton: false,
        timer: 600,
      });
      this.$cookies.set("cleared_cookies_at", new Date().toLocaleTimeString());
    },
    share() {
      if (navigator.share) {
        navigator
          .share({
            title: "TUK App",
            text: "Check out TUK — it rocks!",
            url: "https://tukapp.co",
          })
          .then(() => this.console("Successful share"))
          .catch((error) => this.console("Error sharing", error));
      } else {
        console.error("navigator.share not supported on this device");
      }
    },
    forceClearCache() {
      clearCache();
      this.$swal({
        title: "Cache cleared!",
        text: "Automatically reloading...",
        showConfirmButton: false,
      });
      setTimeout(() => location.reload(), 500);
    },
    toggleSuperUser() {
      this.$store.commit("toggleSuperUser");
    },
    toggleMagic() {
      EventBus.$emit("TOGGLE_MAGIC");
    },
    qrCodes() {
      this.displayModal(".qr-code-generator-modal");
    },
    deliveryPriceCheck() {
      var loader = this.loadingDots();
      this.$store
        .dispatch("checkDeliveryPrice")
        .then((res) => console.log("checkDeliveryPrice", res.data))
        .catch((err) => this.apiError(err)) //console.error("checkDeliveryPrice", err))
        .finally(() => loader.hide());
    },
    checkWelcomeTo() {
      if (!this.$store.state.welcomeTo) return; // return if false
      this.$store.commit("setWelcomeTo", false); // now set false
      this.$store
        .dispatch("reverseGeocode", this.$store.state.userState)
        .then((res) => {
          this.console("reverseGeocode", res);
          if (!res.data.address.country) return; //this.warningAlert(`We can't determine your country, please check your GPS`);
          this.showWelcomeToMessage(res.data.address.country);
        })
        .catch((err) => console.error("reverseGeocode error", err));
    },
    showWelcomeToMessage(country) {
      var title = `Welcome to ${country}!`;
      var html = `TUK has not launched here yet, but please reach out to us if you would like to use the platform.
            <br><br>We're always looking for partners and use cases in new geographies!`;
      var contactUs = false;
      var showCancel = false;
      var confirmText = this.$t("cool");
      var cancelText = this.$t("later");
      switch (country) {
        case "Thailand": // Add other country case statements here as we expand
          html = `TUK's home country 🙏🏽 where we have operations in Bangkok and Chiang Mai with more regions coming soon!
            <br><br>TUK supports transport and logistics-related services and we're always keen to receive feedback and recommendations to help grow the local community 🙌🏽`;
          break;
        case "Myanmar":
          html = `TUK's home country 🙏🏽 where we have operations in Bagan and Pokkoku with more regions coming soon!
            <br><br>TUK supports transport and logistics-related services and we're always keen to receive feedback and recommendations to help grow the local community 🙌🏽`;
          break;
        default:
          if (country === "United States") country = "the United States"; // hack for grammar!
          showCancel = true;
          confirmText = this.$t("contact-us");
      }
      this.$swal({
        title: title,
        html: html,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        showCancelButton: showCancel,
      }).then((val) => {
        if (val.value && contactUs) window.location = "https://m.me/tukapp";
      });
    },
  },
};
</script>

<style scoped>
.image {
  position: fixed;
  /* bottom: 25vh; */
  top: 116px;
  left: 50%;
  transform: translate(-50%, 0);
}
.buttons-wrapper {
  position: fixed;
  top: 228px;
}
</style>
